import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const emailListItemSerializer = Serializers.object({
  id: Serializers.string,
  threadId: Serializers.string,
  from: Serializers.string,
  subject: Serializers.string,
  snippet: Serializers.string,
  date: Serializers.datetime,
  isUnread: Serializers.boolean,
  ticketId: Serializers.string.optional(),
});

export type EmailListItemDto = SerializerValue<typeof emailListItemSerializer>;

const inboxQsSerializer = Serializers.object({
  offset: Serializers.optional(Serializers.integer),
  limit: Serializers.optional(Serializers.integer),
  q: Serializers.string.optional(),
});

const inboxValueSerializer = Serializers.object({
  items: emailListItemSerializer.array(),
  count: Serializers.integer,
});

const emailThreadSerializer = Serializers.object({
  id: Serializers.string,
  threadId: Serializers.string,
  messages: Serializers.array(
    Serializers.object({
      id: Serializers.string,
      from: Serializers.string,
      subject: Serializers.string,
      body: Serializers.string,
      date: Serializers.datetime,
    }),
  ),
});

export const emailActions = {
  emailInbox: HttpAction({
    path: "/email/inbox",
    method: "get",
    qsSerializer: inboxQsSerializer,
    valueSerializer: inboxValueSerializer,
    requiresAuth: true,
  }),

  emailThread: HttpAction({
    path: "/email/thread/:threadId",
    method: "get",
    paramsSerializer: Serializers.object({ threadId: Serializers.string }),
    valueSerializer: emailThreadSerializer,
    errorSerializer: Serializers.stringOneOf("ThreadNotFound"),
    requiresAuth: true,
  }),

  emailSend: HttpAction({
    path: "/email/send",
    method: "post",
    bodySerializer: Serializers.object({
      to: Serializers.string,
      subject: Serializers.string,
      body: Serializers.string,
      threadId: Serializers.string.optional(),
      senderFirstName: Serializers.string.nullable(),
      senderLastName: Serializers.string.nullable(),
    }),
    valueSerializer: Serializers.object({ id: Serializers.string }),
    errorSerializer: Serializers.stringOneOf("SendFailed"),
    requiresAuth: true,
  }),

  emailConvertToTicket: HttpAction({
    path: "/email/convert-to-ticket",
    method: "post",
    bodySerializer: Serializers.object({
      threadId: Serializers.string,
      contactId: Serializers.string.optional(),
    }),
    valueSerializer: Serializers.object({ ticketId: Serializers.string }),
    errorSerializer: Serializers.stringOneOf("ThreadNotFound", "AlreadyLinked"),
    requiresAuth: true,
  }),
};
